import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  BoxProps
} from '@mui/material';

import SvgIcons from '../../components/icons/SvgIcons';
import { DialogModalTitle } from './styled';

interface DialogModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  PaperPropsSx?: BoxProps['sx'];
}

const DialogModal: React.FC<DialogModalProps> = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = 'sm',
  PaperPropsSx
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          ...PaperPropsSx
        }
      }}
    >
      <DialogModalTitle>
        {title}
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 15,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <SvgIcons.Close />
        </IconButton>
      </DialogModalTitle>
      <DialogContent dividers sx={{ p: 2 }}>
        {children}
      </DialogContent>
      {actions && <DialogActions sx={{ p: 2 }}>{actions}</DialogActions>}
    </Dialog>
  );
};

export default DialogModal;
